import script from "./NewsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsView.vue?vue&type=script&setup=true&lang=ts"

import "./NewsView.vue?vue&type=style&index=0&id=2d761fc4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d761fc4"]])

export default __exports__